import React from 'react';
import roKendoMessages from "./assets/json/ro-kendo-messages.json";
import { load, loadMessages, IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";

const language = 'ro';

load(
    require("cldr-core/supplemental/likelySubtags.json"),
    require("cldr-core/supplemental/currencyData.json"),
    require("cldr-core/supplemental/weekData.json"),
    require("cldr-dates-full/main/ro/ca-gregorian.json"),
    require("cldr-dates-full/main/ro/dateFields.json")
);

loadMessages(roKendoMessages, language);

export const LangProvider = (props) => {
    return (<IntlProvider locale={language}>
        <LocalizationProvider language={language}>
            {props.children}
        </LocalizationProvider>
    </IntlProvider>);
}
